<template>
  <div
    class="tw:rounded-t-xl tw:rounded-b-none tw:bg-blue-200 tw:py-11 tw:px-6 tw:flex tw:flex-col tw:lg:flex-row tw:gap-8"
  >
    <div class="tw:flex tw:flex-col tw:w-full tw:lg:w-1/2">
      <h1 class="tw:text-[32px] tw:font-bold tw:mb-4">{{ $t('rc_smartboost_benefit_header') }}</h1>
      <ul class="tw:gap-y-1 tw:flex tw:flex-col">
        <li v-for="(point, index) in points" :key="`point_${index}`" class="tw:flex tw:items-center tw:gap-x-2">
          <CheckPointIcon />
          {{ $t(point) }}
        </li>
      </ul>
      <div class="tw:mt-6">
        <SecondaryButton
          class="icon-btn tw:flex tw:gap-x-2 tw:justify-center tw:items-center tw:mb-2 tw:sm:mb-0"
          @click="openVideo"
        >
          <PlayIcon class="tw:fill-white tw:mr-2" />
          {{ $t('rc_smartboost_video_cta') }}
        </SecondaryButton>
      </div>
    </div>
    <div class="tw:w-full tw:lg:w-1/2 tw:flex tw:justify-center">
      <img :src="smartBoostImage" :alt="$t('rc_smartboost_tab')" />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import SecondaryButton from '@/components/base/buttons/SecondaryButton.vue'
import CheckPointIcon from '@/components/icons/CheckPointIcon.svg?component'
import PlayIcon from '@/components/icons/PlayIcon.svg?component'

import { useIsMobile } from '@/composables/useIsMobile'
import { useSessionValues } from '@/composables/useSessionValues'

const smartBoostImages = import.meta.glob('/src/assets/img/smart-boost/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
})
const { screenWidth } = useIsMobile()
const { language } = useSessionValues()
const currentLocation = computed(() => language.value.split('-')[1].toLowerCase())
const screenSize = computed(() => {
  if (screenWidth.value > 767) {
    return 'm'
  } else {
    return 's'
  }
})
const smartBoostImage = computed(() => {
  const path = `/src/assets/img/smart-boost/smartBoost_${screenSize.value}_${currentLocation.value}.svg`
  return smartBoostImages[path] || ''
})
const emit = defineEmits(['openVideo'])
const openVideo = () => emit('openVideo')
const points = ['rc_smartboost_benefit_1', 'rc_smartboost_benefit_2', 'rc_smartboost_benefit_3']
</script>
